import {Component, OnInit} from '@angular/core';
import {PaylinkSubscription} from '../../models/paylink-subscription';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {EnvironmentService} from '../../services/environment.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {MyBusiness} from '../../models/my-business';
import {Router, RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {PackagePanelComponent} from '../settings/package-panel/package-panel.component';

declare var Snackbar: any;
declare var $: any;

@Component({
  selector: 'app-choose-packages',
  templateUrl: './choose-packages.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, PackagePanelComponent],
  styleUrls: ['./choose-packages.component.scss']
})
export class ChoosePackagesComponent implements OnInit {

  loading: any;
  couponCode: any;
  lang: any;
  myBusiness: MyBusiness;
  submitted: boolean;
  submitting: boolean;
  subscriptions: PaylinkSubscription[];
  marketingSubscriptions: PaylinkSubscription[];

  currentSubscription: PaylinkSubscription;

  constructor(private loader: GlobalLoaderService,
              private formBuilder: FormBuilder,
              private router: Router,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.loading = true;
    this.myBusiness = await this.api.getMyBusiness(false);
    this.currentSubscription = this.myBusiness.paylinkSubscription;
    this.subscriptions = await this.api.getPaylinkSubscriptions();

    setTimeout(async () => {
      await this.loadResources();
      this.lang = await this.translate.get('lang').toPromise();
      this.loading = false;
    }, 1000);
  }

  async submitPackage(subscriptionId) {
    let time = new Date().getTime();
    this.router.navigate(['/private/confirm-package', {subscriptionId: subscriptionId, couponCode: this.couponCode, v: time}]);
  }

  // noinspection DuplicatedCode
  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalStyles('/plugins/dropify/dropify.min.css');
    await this.loader.loadExternalStyles('/assets/css/users/account-setting.css');
    await this.loader.loadExternalScript('/plugins/dropify/dropify.min.js');
    await this.loader.loadExternalScript('/plugins/blockui/jquery.blockUI.min.js');
    await this.loader.loadExternalScript('/assets/js/users/account-settings.js');

    $('.dropify').dropify({
      messages: {
        'default': await this.translate.get('Click to Upload or Drag n Drop').toPromise(),
        'remove': '<i class="flaticon-close-fill"></i>',
        'replace': await this.translate.get('Upload or Drag n Drop').toPromise()
      }
    });
  }

  private static showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  async validateCoupon() {
    this.marketingSubscriptions = await this.api.validateCouponCode(this.couponCode);
    let msg = await this.translate.get('Coupon is invalid').toPromise();
    if (this.marketingSubscriptions == null || this.marketingSubscriptions.length == 0) {
      ChoosePackagesComponent.showToast(msg);
    }
  }
}
